import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import './FicheIdentification.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataProgramme } from '../../data/DataProgramme';

/****************************************************************
 PROPS:
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelProgrammeAdministratif : bool

    onEnregistrementFiche : méthode
    onFermeFicheProgrammeAdministratif : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    programme: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheProgrammeAdministratif extends Component {
    _creationContent() {
        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" name="divDirecteurProgrammeAdjoint">
                        <ComboBoxCompte
                            idAgence={this.state.programme.idAgence}
                            idRegion={this.state.programme.idRegion}
                            idSociete={1}
                            label="Directeur programme adjoint"
                            onChange={(event, option) => this._onMiseAJourChamp("programme", "directeurProgrammeAdjoint", option.key)}
                            selectedKey={this.state.programme.directeurProgrammeAdjoint}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12" name="divDirecteurProgramme">
                        <ComboBoxCompte
                            idAgence={this.state.programme.idAgence}
                            idRegion={this.state.programme.idRegion}
                            idSociete={1}
                            label="Directeur programme"
                            onChange={(event, option) => this._onMiseAJourChamp("programme", "directeurProgramme", option.key)}
                            selectedKey={this.state.programme.directeurProgramme}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12" name="divDirecteurOperationnel">
                        <ComboBoxCompte
                            idAgence={this.state.programme.idAgence}
                            idRegion={this.state.programme.idRegion}
                            idSociete={1}
                            label="Directeur opérationnel"
                            onChange={(event, option) => this._onMiseAJourChamp("programme", "directeurOperationnel", option.key)}
                            selectedKey={this.state.programme.directeurOperationnel}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12" name="divDirecteurTerritorial">
                        <ComboBoxCompte
                            idAgence={this.state.programme.idAgence}
                            idRegion={this.state.programme.idRegion}
                            idSociete={1}
                            label="Directeur territorial"
                            onChange={(event, option) => this._onMiseAJourChamp("programme", "directeurTerritorial", option.key)}
                            selectedKey={this.state.programme.directeurTerritorial}
                        />
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        if (this.props.programme) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du programme en cours'
            });

            var chargementFicheProgrammeAdministratif = DataProgramme._chargementProgramme(this.props.programme.idProgramme, this.props.programme.idRegion, this.props.programme.idAgence);

            chargementFicheProgrammeAdministratif.then(
                responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let retourData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.programme = retourData;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du programme en cours'
        });

        const objet = {
            programme: this.state.programme
        }

        let enregistrementProgramme = DataProgramme._onEnregistrementProgramme(objet);

        enregistrementProgramme
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheProgrammeAdministratif();
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrerProgrammeAdministratif" onClick={() => this._onEnregistrement()} className="marginRight8px">Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    isOpen={this.props.onAffichePanelProgrammeAdministratif}
                    headerText="Administratif"
                    type={PanelType.medium}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    closeButtonAriaLabel="Fermer"
                    onRenderFooterContent={this._onRenderFooterContent}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    }
}